
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ModelValidator } from '@/mixins/ModelValidator'
import { DropdownExtension } from '@/mixins/DropdownExtension'
import { ConfigurationSizeApiModel } from '@/interfaces/ConfigurationSizeApiModel.js'
import { ProductApiModel } from '@/interfaces/ProductApiModel.js'
import ContentScroll from '@/components/common/ContentScroll.vue'
import { namespace } from 'vuex-class'
import lodash from 'lodash'
import ProductRenderer from '@/components/product/ProductRenderer.vue'
const configurationSizes = namespace('configurationSizes')
const currentModel = namespace('currentModel')

@Component({
  components: {
    ProductRenderer,
    ContentScroll
  }
})
export default class SizeConfiguration extends mixins(ModelValidator, DropdownExtension) {
  mounted() {
    this.loadConfigurationSizes(this.model.code)
      .then(() => {
        this.activeWidth = +(this.model.configurator.width)
        this.activeSinks = this.allSinksValue
      })
  }

  created() {
    this.adjustPosition()
  }

  private allSinksValue = 'All';
  private doubleSinksValue = '2';

  public activeSinks: string = this.allSinksValue;

  public activeWidth = 0

  public get activeDepth() {
    return this.model.configurator.depth
  }

  public get confCodeList() {
    const sortedList = lodash.sortBy(this.filteredconfigurationSizeList, ['seq', 'configurationCode'])
    const mappedList = lodash.map(sortedList, 'configurationCode')
    return lodash.uniq(mappedList)
  }

  @configurationSizes.State
  public configurationSizeList!: Array<ConfigurationSizeApiModel>

  @currentModel.Action
  public setModel!: (data: ProductApiModel) => void

  public modelFromCode(confCode: string): ProductApiModel {
    const newModel = lodash.cloneDeep(this.model)

    const configurationSize = this.validConfiguration(confCode)
    if (configurationSize) {
      newModel.configurator.width = configurationSize.width
      newModel.configurator.depth = this.activeDepth
      newModel.configurator.height = configurationSize.height
      newModel.configurator.configuration = configurationSize.configurationCode
      newModel.sizeItemNumber = configurationSize.sizeItemNumber
      newModel.configurator.faucetStyle = configurationSize.faucetStyle
      newModel.configurator.doubleSink = configurationSize.doubleSink
      newModel.configurator.sinkOffset = configurationSize.sinkOffset

      // this.validateAModelAndUpdate(newModel)
    }

    return newModel
  }

  public configurationName(confCode: string): string {
    return confCode
  }

  public validConfiguration(confCode: string): ConfigurationSizeApiModel | undefined {
    const selectedConf = lodash.find(this.filteredconfigurationSizeList, { configurationCode: confCode })
    return selectedConf
  }

  public activeConf(confCode: string): boolean {
    return this.model.configurator.width === this.activeWidth && this.model.configurator.configuration === confCode
  }

  public selectModel(confCode: string): void {
    const data = this.modelFromCode(confCode)
    this.setModel(data)
  }

  public filterSinks(selectedSinks: string) {
    const changingSinks = this.activeSinks !== selectedSinks
    this.activeSinks = selectedSinks
    if (changingSinks) {
      this.selectMatchingConfiguration()
    }
  }

  public filterWidth(width: number) {
    const changingWidth = this.activeWidth !== width
    this.activeWidth = width
    if (this.filteredconfigurationSizeList.length === 0) {
      this.filterSinks(this.allSinksValue)
    } else if (changingWidth) {
      this.selectMatchingConfiguration()
    }
  }

  public setDepth(depth: string) {
    const changingDepth = this.activeDepth !== depth
    if (changingDepth) {
      this.updateModelProperty({ property: 'depth', value: depth })
    }
  }

  private selectMatchingConfiguration() {
    if (this.filteredconfigurationSizeList.length > 0) {
      const configuration = this.filteredconfigurationSizeList.find(c => c.configurationCode === this.model.configurator.configuration) ??
        this.filteredconfigurationSizeList[0]
      this.selectModel(configuration.configurationCode)
    }
  }

  get widthList(): number[] {
    return lodash.sortBy(lodash.uniq(lodash.map(this.configurationSizeList, 'width')))
  }

  get depthList(): string[] {
    return this.model.availableDepths
  }

  get sinksList(): string[] {
    return [this.allSinksValue, '1', this.doubleSinksValue]
  }

  get filteredconfigurationSizeList() {
    return this.configurationSizeList.filter(conf => {
      const validWidth = conf.width === this.activeWidth
      let validSinks = true

      if (this.activeSinks !== this.allSinksValue) {
        const doubleSink = this.activeSinks === this.doubleSinksValue ? 1 : 0
        validSinks = conf.doubleSink === doubleSink
      }
      return validSinks && validWidth
    })
  }
}
